var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { DataTokenType } from '../../types';
import { applyDecimalFormat, applyLengthControl, formatDate } from '../../utils/exportPreviewUtils';
import { guardNumberPositive } from '../../utils/guardNumber';
function lazyLoadFaker() {
    return __awaiter(this, void 0, void 0, function () {
        var module;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, import('@ngneat/falso')];
                case 1:
                    module = _a.sent();
                    return [2 /*return*/, module];
            }
        });
    });
}
export function formatFeeFineToken(attribute) {
    return __awaiter(this, void 0, void 0, function () {
        var faker;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyLoadFaker()];
                case 1:
                    faker = _a.sent();
                    if (attribute === 'FEE_FINE_TYPE_ID') {
                        return [2 /*return*/, faker.randUuid()];
                    }
                    else {
                        return [2 /*return*/, "".concat(faker.randWord(), " ").concat(faker.randWord())];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function formatItemToken(attribute) {
    return __awaiter(this, void 0, void 0, function () {
        var faker;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyLoadFaker()];
                case 1:
                    faker = _a.sent();
                    switch (attribute) {
                        case 'BARCODE':
                            return [2 /*return*/, faker.randPassword({ size: 11 })];
                        case 'NAME':
                            return [2 /*return*/, faker.randTextRange({ min: 10, max: 50 })];
                        case 'MATERIAL_TYPE':
                            return [2 /*return*/, faker.randWord()];
                        default:
                            return [2 /*return*/, faker.randUuid()];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function formatUserToken(attribute) {
    return __awaiter(this, void 0, void 0, function () {
        var faker;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyLoadFaker()];
                case 1:
                    faker = _a.sent();
                    switch (attribute) {
                        case 'BARCODE':
                        case 'EXTERNAL_SYSTEM_ID':
                            return [2 /*return*/, faker.randPassword({ size: 10 })];
                        case 'USERNAME':
                            return [2 /*return*/, faker.randUserName()];
                        case 'FIRST_NAME':
                            return [2 /*return*/, faker.randFirstName()];
                        case 'MIDDLE_NAME':
                            return [2 /*return*/, faker.randLastName()];
                        case 'LAST_NAME':
                            return [2 /*return*/, faker.randLastName()];
                        default:
                            return [2 /*return*/, faker.randUuid()];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function tokenToString(dataToken, amount, count) {
    return __awaiter(this, void 0, void 0, function () {
        var faker, _a, _b, _c, _d;
        var _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0: return [4 /*yield*/, lazyLoadFaker()];
                case 1:
                    faker = _g.sent();
                    _a = dataToken.type;
                    switch (_a) {
                        case DataTokenType.ARBITRARY_TEXT: return [3 /*break*/, 2];
                        case DataTokenType.NEWLINE: return [3 /*break*/, 3];
                        case DataTokenType.NEWLINE_MICROSOFT: return [3 /*break*/, 4];
                        case DataTokenType.TAB: return [3 /*break*/, 5];
                        case DataTokenType.COMMA: return [3 /*break*/, 6];
                        case DataTokenType.SPACE: return [3 /*break*/, 7];
                        case DataTokenType.CURRENT_DATE: return [3 /*break*/, 8];
                        case DataTokenType.AGGREGATE_TOTAL: return [3 /*break*/, 9];
                        case DataTokenType.ACCOUNT_AMOUNT: return [3 /*break*/, 9];
                        case DataTokenType.ACCOUNT_DATE: return [3 /*break*/, 10];
                        case DataTokenType.FEE_FINE_TYPE: return [3 /*break*/, 11];
                        case DataTokenType.ITEM_INFO: return [3 /*break*/, 13];
                        case DataTokenType.USER_DATA: return [3 /*break*/, 15];
                        case DataTokenType.CONSTANT_CONDITIONAL: return [3 /*break*/, 17];
                        case DataTokenType.AGGREGATE_COUNT: return [3 /*break*/, 18];
                    }
                    return [3 /*break*/, 19];
                case 2: return [2 /*return*/, (_e = dataToken.text) !== null && _e !== void 0 ? _e : ''];
                case 3: return [2 /*return*/, '\n'];
                case 4: return [2 /*return*/, '\r\n'];
                case 5: return [2 /*return*/, '\t'];
                case 6: return [2 /*return*/, ','];
                case 7: return [2 /*return*/, ' '.repeat(guardNumberPositive(dataToken.repeat))];
                case 8: return [2 /*return*/, applyLengthControl(formatDate(dataToken.format, new Date()).toString(), dataToken.lengthControl)];
                case 9: return [2 /*return*/, applyLengthControl(applyDecimalFormat(amount, dataToken.decimal), dataToken.lengthControl)];
                case 10: return [2 /*return*/, applyLengthControl(formatDate(dataToken.format, faker.randPastDate()).toString(), dataToken.lengthControl)];
                case 11:
                    _b = applyLengthControl;
                    return [4 /*yield*/, formatFeeFineToken(dataToken.feeFineAttribute)];
                case 12: return [2 /*return*/, _b.apply(void 0, [_g.sent(), dataToken.lengthControl])];
                case 13:
                    _c = applyLengthControl;
                    return [4 /*yield*/, formatItemToken(dataToken.itemAttribute)];
                case 14: return [2 /*return*/, _c.apply(void 0, [_g.sent(), dataToken.lengthControl])];
                case 15:
                    _d = applyLengthControl;
                    return [4 /*yield*/, formatUserToken(dataToken.userAttribute)];
                case 16: return [2 /*return*/, _d.apply(void 0, [_g.sent(), dataToken.lengthControl])];
                case 17: return [2 /*return*/, faker.rand(__spreadArray(__spreadArray([], ((_f = dataToken.conditions) !== null && _f !== void 0 ? _f : []).map(function (cond) { return cond.value; }).filter(function (v) { return v; }), true), [
                        dataToken.else,
                    ], false))];
                case 18: return [2 /*return*/, applyLengthControl(count.toString(), dataToken.lengthControl)];
                case 19: return [2 /*return*/, ''];
            }
        });
    });
}
export function generateEntry(tokens, isAggregate) {
    return __awaiter(this, void 0, void 0, function () {
        var faker, amount, count, elements;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyLoadFaker()];
                case 1:
                    faker = _a.sent();
                    amount = faker.randFloat({ min: 5, max: 100, precision: 0.01 });
                    count = isAggregate ? faker.randNumber({ min: 1, max: 10 }) : 1;
                    return [4 /*yield*/, Promise.all(tokens.map(function (token) { return tokenToString(token, amount, count); }))];
                case 2:
                    elements = _a.sent();
                    return [2 /*return*/, Promise.resolve({
                            elements: elements,
                            amount: amount,
                            count: count,
                        })];
            }
        });
    });
}
export default function createPreviewData(tokens, isAggregate) {
    return __awaiter(this, void 0, void 0, function () {
        var faker, numEntries, results, totalAmount, totalCount, i, _a, elements, amount, count;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, lazyLoadFaker()];
                case 1:
                    faker = _b.sent();
                    numEntries = faker.randNumber({ min: 3, max: 12 });
                    results = [];
                    totalAmount = 0;
                    totalCount = 0;
                    i = 0;
                    _b.label = 2;
                case 2:
                    if (!(i < numEntries)) return [3 /*break*/, 5];
                    return [4 /*yield*/, generateEntry(tokens, isAggregate)];
                case 3:
                    _a = _b.sent(), elements = _a.elements, amount = _a.amount, count = _a.count;
                    results.push.apply(results, elements);
                    totalAmount += amount;
                    totalCount += count;
                    _b.label = 4;
                case 4:
                    i++;
                    return [3 /*break*/, 2];
                case 5: return [2 /*return*/, Promise.resolve({
                        dataPreview: results.join(''),
                        totalAmount: totalAmount,
                        totalCount: totalCount,
                    })];
            }
        });
    });
}
